/* eslint-disable @typescript-eslint/no-namespace */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import WindowUtil from './WindowUtil';

namespace WindowHooks {
  // URLのハッシュがあればその位置までスクロールし、なければページトップまでスクロールする。以降もハッシュが切り替わる度にスクロールする。
  export function useScrollToHashOrTop(): void {
    const location = useLocation();

    useEffect(
      () => {
        const timer = setTimeout(() => WindowUtil.scrollToHashOrTop(location), 1000);
        return () => clearTimeout(timer);
      },
      [location.hash], // eslint-disable-line react-hooks/exhaustive-deps
    );
  }
}

export default WindowHooks;
